import React from "react";
import useOrgMembersApi from "./hooks/use-org-members-api";

const MembersContext = React.createContext();
MembersContext.displayName = "MembersContext";
const TeamPlanMembersContext = React.createContext();
TeamPlanMembersContext.displayName = "TeamPlanMembersContext";

const MembersProvider = (props) => {
    const orgMembersApi = useOrgMembersApi();
    return <MembersContext.Provider value={orgMembersApi} {...props} />;
};

const useMembers = () => {
    const context = React.useContext(MembersContext);
    if (context === undefined) {
        throw new Error(`useMembers must be used within a MembersProvider`);
    }
    return context;
};

export { MembersProvider, useMembers };
